module.exports = __webpack_public_path__ + "static/media/37_tn.e2f9512f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/37_tn.jpg
// module id = 673
// module chunks = 0